export const transactionObject = {
  account: '0xa6a6c88ab10347e32def9912b0887722c4e95aa1',
  hash: '0x9f4ba8e5c0632b4d1c5c2988de69f58e3b4d3b99bfb6518b0e5b0f1c617a2b8a',
  status: 'success',
  chainId: 1,
  chain: 'eth',
  addedTime: 1687440267770,
  action: {
    action: 'buy',
    network: 'Mainnet',
    indexDetails: {
      indexTicker: 'PDI',
      assetName: 'ETH',
      assetDecimals: 18,
      value: {
        type: 'BigNumber',
        hex: '0x0de0b6b3a7640000',
      },
    },
    stakingDetails: {
      assetName: 'ETH',
      assetDecimals: 18,
      value: {
        type: 'BigNumber',
        hex: '0x0de0b6b3a7640000',
      },
    },
  },
  lastCheckedBlockNumber: 31659199,
  receipt: {
    to: '0xDef1C0ded9bec7F1a1670819833240f027b25EfF',
    from: '0xa6A6C88ab10347E32dEF9912B0887722c4e95aA1',
    contractAddress: null,
    transactionIndex: 7,
    gasUsed: {
      type: 'BigNumber',
      hex: '0x048839',
    },
    logsBloom:
      '0x00208000000000004000001080000000000000000001000028000000002000000001000000000000004000800000000000000000000000000000000000000000000080000090008000020008800000200000000000000000000000008000000000000000020004000000001000010800010000000002000200000010000000000000000000000000000000000000000000000001000004080000004000000000008010000000400000000000200001000000000000000000000000000000004001000002000000000000000000000000000000000000001000000000000020000000000004000000000000000000000c00000000000000600000000000001400',
    blockHash: '0x9577e08a4ec8ecca1df661b8f247ab50740f1ed0facb4fe15cf6291f048f675a',
    transactionHash: '0x9f4ba8e5c0632b4d1c5c2988de69f58e3b4d3b99bfb6518b0e5b0f1c617a2b8a',
    blockNumber: 31659250,
    confirmations: 1,
    cumulativeGasUsed: {
      type: 'BigNumber',
      hex: '0x1bc514',
    },
    effectiveGasPrice: {
      type: 'BigNumber',
      hex: '0x0670642932',
    },
    status: 1,
    type: 2,
    byzantium: true,
  },
}

export default transactionObject
